import { Menu as MantineMenu, MenuProps } from '@mantine/core';

export type IMenuProps = MenuProps;

/** @registry Design-layer pass-through over Mantine Menu; import this instead of @mantine/core Menu outside src/design. Extend here when Menu needs house behavior. Compound statics (Menu.Target, Menu.Dropdown, Menu.Item, ...) are preserved. */
export const Menu = MantineMenu;
